import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// 移动端断点:宽度 < md(900px)时启用底部导航布局
export function useIsMobile(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}
